import React, { FC } from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';
import Link from '@mui/material/Link';

const Copyright: FC<TypographyProps> = props => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}>
      ©{' '}
      <Link color="inherit" href="https://tedo.lt/" component="a">
        Tedo.lt
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
};

export default Copyright;
